var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare2 = function SvgShare2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.488 3.424c.304.527.867.882 1.512.882.966 0 1.75-.796 1.75-1.778S13.966.75 13 .75s-1.75.796-1.75 1.778c0 .326.087.633.238.896Zm0 0-7.476 4.43m0 0A1.744 1.744 0 0 0 2.5 6.972c-.966 0-1.75.796-1.75 1.778s.784 1.778 1.75 1.778c.645 0 1.208-.355 1.512-.882m0-1.792c.151.263.238.57.238.896 0 .327-.087.633-.238.896m0 0 7.476 4.43m0 0A1.745 1.745 0 0 1 13 13.194c.966 0 1.75.796 1.75 1.778S13.966 16.75 13 16.75s-1.75-.796-1.75-1.778c0-.326.087-.633.238-.896Z"
  })));
};
export default SvgShare2;